{
  "login": {
    "heading": "Iniciar sesión",
    "intro": "Esta historia clínica se utiliza cuando el sistema central de historia clínica no está disponible. Inicie sesión con su cuenta de demostración.",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "submit": "Iniciar sesión",
    "submitting": "Iniciando sesión …",
    "missing": "Introduzca el nombre de usuario y la contraseña."
  },
  "refusal": {
    "invalidCredentials": "Nombre de usuario o contraseña incorrectos.",
    "unknown": "Se ha denegado el inicio de sesión. Compruebe el nombre de usuario y la contraseña e inténtelo de nuevo.",
    "unavailable": "El sistema no responde. Contacte con el servicio técnico de guardia y, mientras tanto, documente en papel.",
    "roleMayNotDocument": "Ha iniciado sesión como {role} y puede leer la historia clínica, pero no documentar en ella."
  },
  "role": {
    "physician": "Médico",
    "nurse": "Personal de enfermería"
  },
  "signedInAs": "{name} ({role})",
  "session": {
    "logout": "Cerrar sesión",
    "expired": "Se ha cerrado su sesión. Vuelva a iniciar sesión para continuar."
  }
}
